import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaSnapchat,
  FaThreads,
  FaTiktok,
  FaTwitter,
  FaWeixin,
} from "react-icons/fa6";
import { Socials } from "../types";

// Function to get the icon for a given social media platform
export const SocialMediaIcons = ({ platform }: { platform: keyof Socials }) => {
  const socialIcon: Record<keyof Socials, JSX.Element> = {
    facebook: <FaFacebookF />,
    instagram: <FaInstagram />,
    tiktok: <FaTiktok />,
    x: <FaTwitter />,
    linkedin: <FaLinkedinIn />,
    snapchat: <FaSnapchat />,
    threads: <FaThreads />,
    wechat: <FaWeixin />,
  };

  return socialIcon[platform];
};
